<script setup>
defineProps({ blok: Object })
const target = ref(null)
const targetIsVisible = ref(false)

const { stop } = useIntersectionObserver(
  target,
  ([{ isIntersecting }], observerElement) => {
    if (isIntersecting)
      targetIsVisible.value = isIntersecting
  },
)
</script>

<template>
  <div ref="target" v-editable="blok" class="pb-mobile lg:pb-desktop">
    <div class="container">
      <h2 :class="[targetIsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-15px]']" class="transition-[transform,opacity] duration-700 delay-200 ease-in-out mx-auto mb-custom-lg text-center text-3xl font-bold capitalize lg:max-w-3xl xl:max-w-4xl md:text-4xl xl:text-5xl">
        {{ blok.title }}
      </h2>
      <p :class="[targetIsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[15px]']" class="transition-[transform,opacity] duration-700 delay-400 ease-in-out mb-custom-xl text-center text-xl leading-[1.6]">
        {{ blok.subtitle }}
      </p>
      <ContentMembershipsLogo :is-visible="targetIsVisible" :story="blok.media" />
    </div>
  </div>
</template>